/* eslint-disable @typescript-eslint/unbound-method */
import { Component, Input, type OnInit } from '@angular/core';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { CmsService } from '../../services/cms.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { FormBuilder, FormControl, type FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-email-form',
  imports: [FormsModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule],
  templateUrl: './email-form.component.html',
  styleUrl: './email-form.component.scss',
})
export class EmailFormComponent implements OnInit {
  @Input() emailData: any;
  pageLabels: any;
  emailForm!: FormGroup;
  pageReady = false;
  constructor(
    private readonly cms: CmsService,
    private readonly formBuilder: FormBuilder,
  ) {}

  ngOnInit(): void {
    this.cms.getContent('oas-email-component', 'OAS Email Component').subscribe((data) => {
      this.pageLabels = data;
      this.emailForm = this.emailData.formGroup;
      this.pageReady = true;
    });
  }

  get email(): FormControl {
    return this.emailForm.get('email') as FormControl;
  }

  get emailConfrim(): FormControl {
    return this.emailForm.get('emailConfirm') as FormControl;
  }

  confirmEmailsMatch(): void {
    const email = this.emailForm.get('email');
    const emailConfirm = this.emailForm.get('emailConfirm');
    if (email && emailConfirm) {
      const emailValue = this.emailForm.get('email')?.value;
      const confirmEmailValue = this.emailForm.get('emailConfirm')?.value;
      if (emailValue === confirmEmailValue && emailValue.length > 0 && confirmEmailValue.length > 0) {
        emailConfirm.setErrors(null);
      } else if (emailValue.length > 0 && confirmEmailValue.length > 0) {
        if (emailValue !== confirmEmailValue) {
          emailConfirm.setErrors({ emails2DontMatch: true });
        }
      }
    }
  }
}
